// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerCommonDataStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Izenda Other Settings Store
 */
!(function() {
  var fetcher = require('fetchers/Izenda.ReportDesignerDataFetcher');
  var jsFormatService = require('share/Izenda.JsFormatService');
  var { DATA_TYPES } = require('logic/data/Izenda.ReportDesignerConstants');
  var { isNil, forEach, filter } = require('lodash/fp');

  var commonData = {
    DATA_TYPE: {}
  };

  /**
   * Get data from commonData based on dataType and key
   * @param  {[type]} dataType [description]
   * @param  {[type]} key      [description]
   * @return {[type]}          [description]
   */
  function getData(dataType, key) {
    return commonData[dataType] && commonData[dataType][key];
  }

  /**
   * Set data to commonData based on dataType, key and value
   * @param {[type]} dataType [description]
   * @param {[type]} key      [description]
   * @param {[type]} value    [description]
   */
  function setData(dataType, key, value) {
    commonData[dataType] = commonData[dataType] || {};
    commonData[dataType][key] = value;
  }

  module.exports = {
    /**
     * Load list of data format based on dataType for filter
     * @param  {string} dataFormatType
     * @return {promise}
     */
    loadFilterDataFormat: function(dataFormatType) {
      var key = 'FILTER_DATA_TYPE';
      var cachedPromise = getData(key, dataFormatType);

      if (isNil(cachedPromise) || cachedPromise.isRejected()) {
        // cache promised object
        cachedPromise = fetcher.loadFilterDataFormat(dataFormatType);
        setData(key, dataFormatType, cachedPromise);
      }

      return cachedPromise.catch(function() {
        return [];
      });
    },

    /**
     * Load list of function for report part: field properties, sub total, grand total
     * @param  {string} functionMode
     * @param  {string} dataFormatType
     * @param  {array} querySourceIds
     * @return {promise}
     */
    loadReportFunction: function(functionMode, dataFormatType, tenantId, querySourceIds) {
      return fetcher.loadReportFunction(functionMode, dataFormatType, tenantId, querySourceIds);
    },

    /**
     * Get list of data-format for report part, field properties
     * @param  {[type]} dataFormatType [description]
     * @return {[type]}                [description]
     */
    loadReportFieldDataFormat: function(dataFormatType, withoutCache) {
      var key = 'RP_FIELD_DATA_TYPE';
      var cachedPromise;

      if (!withoutCache) {
        cachedPromise = getData(key, dataFormatType);
      }

      // check if have cached or cached promise is rejected
      if (isNil(cachedPromise) || cachedPromise.isRejected()) {
        // cache promised object
        cachedPromise = fetcher.loadReportFieldDataFormat(dataFormatType);
        !withoutCache && setData(key, dataFormatType, cachedPromise);
      }

      return cachedPromise.catch(function() {
        return [];
      });
    },

    /**
     * Get list of custom data-format for report part, field properties
     * @param  {[type]} dataFormatType [description]
     * @return {[type]}                [description]
     */
    loadCustomDataFormat: function(dataFormatType, withoutCache) {
      var key = 'RP_FIELD_DATA_TYPE';
      var cachedPromise;

      if (!withoutCache) {
        cachedPromise = getData(key, dataFormatType);
      }

      if (isNil(cachedPromise) || cachedPromise.isRejected()) {
        cachedPromise = fetcher.loadReportFieldDataFormat(DATA_TYPES.CUSTOM).then((data) => {
          const customDataFormats = filter(item => item.jsFormatString !== null, data);
          forEach(customDataFormat => {
            jsFormatService.registerJsFormatString(customDataFormat.name, customDataFormat.jsFormatString);
          }, customDataFormats);
        });
        !withoutCache && setData(key, dataFormatType, cachedPromise);
      }

      return cachedPromise.catch(function() {
        return [];
      });
    },
  };
})();



// WEBPACK FOOTER //
// ./ui/logic/Izenda.ReportDesignerCommonDataStore.js